import { Header } from '../components/Header/Header';
import { HomePage } from '../components/Homepage/HomePage';
import { ProjectForm } from '../components/ProjectForm/ProjectForm';
import { WorkSpace } from '../components/WorkSpace/WorkSpace';
import { observer } from 'mobx-react-lite';
import { useMainContext } from '../hooks/useMainContext';
import { PageTypes } from '../config';
import { useEffect } from 'react';
import { handleKeyDown, handleWheel } from '../utils/uiUtils';

export const Index = observer(() => {
    const { viewManager } = useMainContext();
    useEffect(() => {
        document.addEventListener('keydown', handleKeyDown);
        document.addEventListener('wheel', handleWheel, { passive: false });

        return () => {
            document.removeEventListener('keydown', handleKeyDown);
            document.removeEventListener('wheel', handleWheel);
        };
    }, []);
    return (
        <div>
            <Header />
            {viewManager.currentPage === PageTypes.WorkSpace && <WorkSpace />}
            {viewManager.currentPage === PageTypes.HomePage && (
                <>
                    <HomePage />
                    <ProjectForm />
                </>
            )}
        </div>
    );
});
